export default __webpack_public_path__ + "static/media/Headdress of the Blood God.6e94c83b.jpg";